import axios from 'axios';
import { baseDomain } from '@/common/config'
import { service } from '@/utils/request.js'

// ============ 人物库管理 ============
const Api = {
  Person_Page: baseDomain + '/person/page', // 人物分页查询
  Person_Detail: baseDomain + '/person/', // 人物详情
  Person_Create: baseDomain + '/person/create', // 新增人物
  Person_Update: baseDomain + '/person/update', // 编辑人物
  Person_Delete: baseDomain + '/person/', // 删除人物
}

// ============ 人物库管理 API ============

// 人物分页查询
export const reqPersonPage = (params) => {
  return service({
    url: Api.Person_Page,
    method: 'POST',
    data: params
  })
}

// 人物详情
export const reqPersonDetail = (id) => {
  return service({
    url: Api.Person_Detail + id,
    method: 'GET',
  })
}

// 新增人物
export const reqPersonCreate = (params) => {
  return service({
    url: Api.Person_Create,
    method: 'POST',
    data: params
  })
}

// 编辑人物
export const reqPersonUpdate = (params) => {
  return service({
    url: Api.Person_Update,
    method: 'PUT',
    data: params
  })
}

// 删除人物
export const reqPersonDelete = (id) => {
  return service({
    url: Api.Person_Delete + id,
    method: 'DELETE',
  })
}
